module.exports = __webpack_public_path__ + "static/media/ameen.b37aebcb.jpg";